import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./FormLaminFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";

import { useEffect, useState } from "react";
import FormLaminFormStepOne from "./FormLaminFormSteps/FormLaminFormStepOne";

const FormLaminForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    if (update) {
      setInitialValues({
        ..._initialValues,
        drawings: _initialValues?.drawings || [],       
        projects: _initialValues?.projects || [],
        type: _initialValues?.type?.uuid
          ? { value: _initialValues?.type?.uuid }
          : null,
      });
      return;
    }

    setInitialValues({});
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, props)}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="DrawingForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <FormLaminFormStepOne {...formProps} {...props} />
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default FormLaminForm;
